import './ChatPromptWalker.css';

/**
 * AI Chat prompt kutusunun üst kenarında, yüzü bize dönük duran overlay karakter.
 * Tıklamaları geçirir.
 */
export function ChatPromptWalker() {
    return (
        <div className="chat-prompt-walker" aria-hidden="true">
            <div className="chat-prompt-walker-actor">
                <div className="chat-prompt-walker-shadow" />
                <div className="chat-prompt-walker-figure">
                    <span className="chat-prompt-walker-arm left" />
                    <span className="chat-prompt-walker-arm right" />
                    <span className="chat-prompt-walker-leg left" />
                    <span className="chat-prompt-walker-leg right" />
                    <span className="chat-prompt-walker-torso" />
                    <span className="chat-prompt-walker-head">
                        <span className="chat-prompt-walker-hair" />
                        <span className="chat-prompt-walker-brow left" />
                        <span className="chat-prompt-walker-brow right" />
                        <span className="chat-prompt-walker-eye left" />
                        <span className="chat-prompt-walker-eye right" />
                        <span className="chat-prompt-walker-nose" />
                        <span className="chat-prompt-walker-mouth" />
                    </span>
                </div>
            </div>
        </div>
    );
}
